import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@packages/api';

async function getCallContent(callId: number, contentId: string) {
  const res = await apiFetch(`/api/v17/calls/${callId}/content/${contentId}`);
  if (!res.ok) throw new Error(`Failed to fetch call content: ${res.status}`);
  return res.json();
}

export function useCallContent(callId: number, contentId: string | undefined) {
  return useQuery({
    queryKey: ['callContent', callId, contentId],
    queryFn: () => getCallContent(callId, contentId!),
    enabled: !!contentId,
    refetchInterval: (query) => {
      const data = query.state.data;
      const hasDbResource = data?.resources?.some(
        (r: { uri: string }) => r.uri.startsWith('db://')
      );
      return hasDbResource ? 5000 : false;
    },
  });
}
